import React, { Component } from "react";
import { AxiosResponse, AxiosError } from "axios";
import { Api } from "../../../../utils/Api";
import { CoursesResource } from "../../../../stores/CoursesStore/Types";
import { Carousel } from "../../../common";
import Course from "../Courses/Course";
import NewCourse from "../Courses/NewCourse";

interface Props {
  showHeading: boolean;
  userIsInUk: boolean;
}

interface State {
  featuredCourses: CoursesResource;
  loading: boolean;
}

class SampleCourses extends Component<Props, State> {
  static defaultProps = { showHeading: true };

  constructor(props) {
    super(props);

    this.state = {
      featuredCourses: [],
      loading: true,
    };
  }

  componentDidMount() {
    const client = new Api({});
    client
      .get<CoursesResource>("/api/sample_courses.json")
      .then((response: AxiosResponse<CoursesResource>) => {
        const { data } = response;
        this.setState({
          featuredCourses: data,
          loading: false,
        });
      })
      .catch((error: AxiosError) => {
        console.error(error.response?.statusText);
      });
  }
  scrollCarousel = (gridId, cardSelector, direction) => {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    const card = grid.querySelector(cardSelector);
    if (!card) return;
    const scrollAmount = (card.offsetWidth + 20) * direction;
    grid.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  scrollTry = (direction: number) => {
    this.scrollCarousel("tryGrid", ".try-card", direction);
  };

  render() {
    const { showHeading, userIsInUk } = this.props;

    const { featuredCourses, loading } = this.state;
    const categories = featuredCourses.map((course) => course.categories);

    return (
      <div
        className="ui segment courses sample-courses"
        id="sample-courses-container"
      >
        {loading && (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        )}

        <section className="try-section">
          <div className="container">
            <div className="header">
              <h2 className="section-title" id="try-title">
                Try Before You Buy
              </h2>
              <p className="section-sub" style={{ margin: "8px auto 0" }}>
                Sceptical? Good. Enrol in a free sample course and let the
                quality do the talking.
              </p>
            </div>
          </div>
          <div className="try-carousel">
            <div className="ui container" style={{ padding: "0" }}>
              <button
                className="try-nav prev"
                onClick={() => this.scrollTry(-1)}
                aria-label="Previous courses"
              >
                ‹
              </button>
              <div className="course-grid try-grid" id="tryGrid">
                {featuredCourses.map((course, i) => (
                  <NewCourse
                    courseResource={course}
                    key={course.id}
                    userIsInUk={userIsInUk}
                    cardClass="try-card"
                    isSample={true}
                  />
                ))}
              </div>
              <button
                className="try-nav next"
                onClick={() => this.scrollTry(1)}
                aria-label="Previous courses"
              >
                ›
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default SampleCourses;
